// extracted by mini-css-extract-plugin
export default {"header":"styles_header__g-3NR","overskrift":"styles_overskrift__lcYhX","iconContainer":"styles_iconContainer__hW3RF"};